<template>
  <div class="blog-slider">
    <div class="swiper-container" ref="blogSwiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide reverse"
          v-for="(article, index) in data"
          :key="index"
        >
          <div
            class="image-block reverse"
            data-aos="fade-up"
            data-aos-duration="400"
            :style="{ backgroundImage: `url(${article.image.src})` }"
          ></div>
          <div class="text-block">
            <div class="text-wrapper">
              <span>{{ translation.latest }}</span>
              <h2 class="section-title">{{ article.title }}</h2>
              <p class="section-description" v-html="article.summary_html"></p>
              <a class="btn" :href="`/blogs/news/${article.handle}`">{{
                translation.read_more
              }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-button-prev" ref="prev"></div>
      <div class="swiper-button-next" ref="next"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/dist/js/swiper.js";

export default {
  props: {
    articles: { type: Array, required: true },
  },
  computed: {
    data: (t) => t.articles.map((x) => JSON.parse(x)),
  },
  data() {
    return {
      translation: this.$translations.blog,
    };
  },
  mounted() {
    // init swiper
    const blogSwiper = new Swiper(this.$refs.blogSwiper, {
      slidesPerView: 1,
      watchOverflow: true,
      speed: 500,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev,
      },
    });
  },
};
</script>

<style lang="scss" scoped>
.blog-slider {
  background-color: $grey;
  margin: 140px auto 140px;
  @include res(tab-p) {
    margin: 100px 0px 50px;
  }
  .swiper-container {
    width: 100%;
    height: 100%;
    overflow: visible;
    .swiper-slide {
      position: relative;
      display: flex;
      justify-content: space-between;
      @include res(tab-l) {
        flex-direction: column;
        align-items: center;
      }
      &.reverse {
        flex-direction: row-reverse;
        @include res(tab-l) {
          flex-direction: column;
          align-items: center;
        }
      }
      .image-block {
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        width: 52%;
        bottom: 55px;
        padding-top: 52%;
        @include res(tab-l) {
          width: 65%;
          padding-top: 65%;
        }
        @include res(tab-p) {
          width: 80%;
          padding-top: 80%;
        }
        &.reverse {
          right: 55px;
          @include res(tab-l) {
            right: 0;
          }
        }
        &.basic {
          left: 55px;
          @include res(tab-l) {
            left: 0;
          }
        }
      }
      .text-block {
        max-width: 45%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 20px;
        @include res(tab-p) {
          max-width: 80%;
        }
        .text-wrapper {
          max-width: 350px;
          text-align: center;
          margin: 0 50px;
          font-weight: 400;
          @include res(tab-l) {
            max-width: 100%;
            margin: 0 0 35px;
          }
          span {
            color: $brown;
            font-size: 14px;
            line-height: 20px;
            font-family: $font-text;
            text-transform: uppercase;
            margin-bottom: 15px;
            display: inline-block;
          }
          .section-description {
            font-size: 14px;
            line-height: 22px;
            margin: 15px 15px;
            @include res(tab-p) {
              margin: 15px 0;
            }
            p {
              margin-top: 15px !important;
            }
          }
          h2 {
            text-transform: uppercase;
            margin: 0;
          }
          a {
            color: $dark-grey;
          }
          a.btn {
            @include button(#5C5C5C, 10px, 15px);
            border: 1px solid $dark-grey;
            display: inline-block;
            text-transform: uppercase;
            &:hover {
              color: $white;
            }
            &::before {
              @include button-hover($bg: #5C5C5C);
              color: $white;
            }
            @include res(tab-p) {
              width: 100%;
            }
          }
        }
      }
    }
    .swiper-button-prev,
    .swiper-button-next {
      width: 30px;
      height: 20px;
      background-size: contain;
      outline: none;
      top: 97%;
    }
    .swiper-button {
      &-prev {
        right: 50px;
        left: auto;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14.188' height='24' viewBox='0 0 14.188 24'%3E%3Cpath id='Path_116' data-name='Path 116' d='M12,0,0,12l2.187,2.188L12,4.375l9.813,9.812L24,12Z' transform='translate(0 24) rotate(-90)' fill='currentColor'/%3E%3C/svg%3E%0A");
        @include res(mobile) {
          display: none;
        }
      }
      &-next {
        right: 25px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14.188' height='24' viewBox='0 0 14.188 24'%3E%3Cpath id='Path_146' data-name='Path 146' d='M12,14.188l-12-12L2.187,0,12,9.812,21.813,0,24,2.187Z' transform='translate(0 24) rotate(-90)' fill='currentColor'/%3E%3C/svg%3E%0A");
        @include res(mobile) {
          display: none;
        }
      }
    }
  }
}
</style>
